import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import { GlobalErrorService } from '@services/global-error.service'
import { AuthRedirectService } from '../../services/auth-redirect.service'

@Component({
  selector: 'albert-auth-callback',
  standalone: true,
  template: `
    <div class="flex items-center justify-center h-screen">
      <div class="text-xl">Authenticating...</div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthCallbackComponent implements OnInit {
  private readonly authService = inject(AuthService)
  private readonly router = inject(Router)
  private readonly globalErrorService = inject(GlobalErrorService)
  private readonly authRedirectService = inject(AuthRedirectService)

  public ngOnInit(): void {
    this.authService.handleRedirectPromise().subscribe({
      next: () => {
        void this.router.navigateByUrl(this.authRedirectService.consume(), { replaceUrl: true })
      },
      error: () => {
        this.globalErrorService.reportError({
          subsystemName: 'User Authentication',
          description: `The user authentication did not succeed`
        })
        this.authRedirectService.consume()
        void this.router.navigate(['/'])
      }
    })
  }
}
